import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { of } from "rxjs";
import { switchMap } from "rxjs/operators";

import { protocolPanelActions } from "./protocol.actions";
import { pipelineActions } from "../pipelines";
import { stepActions } from "../steps";
import { methodTypeActions } from "../method-types";

@Injectable()
export class TelespotProtocolEffects {

  constructor(
    private actions$: Actions,
  ) { }

  // on protocol.findForSample, find pipelines for sample
  findPipelinesForSample = createEffect(() =>
    this.actions$.pipe(
      ofType(protocolPanelActions.selectSample),
      switchMap(({ sampleId }) => of(pipelineActions.findForSample({ sampleId }))),
    )
  );

  // on protocol.findForSample, find steps for sample
  findStepsForSample = createEffect(() =>
    this.actions$.pipe(
      ofType(protocolPanelActions.selectSample),
      switchMap(({ sampleId }) => of(stepActions.findForSample({ sampleId }))),
    )
  );

  // on protocol.findForSample, find method types for sample
  findMethodTypesForSample = createEffect(() =>
    this.actions$.pipe(
      ofType(protocolPanelActions.selectSample),
      switchMap(({ sampleId }) => of(methodTypeActions.findForSample({ sampleId }))),
    )
  );

  findMethodTypesForSampleSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(methodTypeActions.findForSampleSuccess),
      switchMap(({ methodType }) => of(protocolPanelActions.selectSampleSuccess({ methodType: methodType.id }))),
    )
  );
}
